import profileImage1 from "./assets/football.jpg"
import profileImage2 from "./assets/black-white.jpg"
import profileImage3 from "./assets/green-white.jpg"
import profileImage4 from "./assets/red-white.jpg"

export const players = [
    {   
        id: 1,
        name: "Player 1",
        team: "Team",
        nationality: "Nationality",
        jerseyNumber: "jerseyNumber",
        age: "Age",
        profileImage: profileImage1,
        background: "linear-gradient(to bottom right, blue, white)",
        border: "2px solid blue",
    },
    {   
        id: 2,
        name: "Player 2",
        team: "Team",
        nationality: "Nationality",
        jerseyNumber: "jerseyNumber",
        age: "Age",
        profileImage: profileImage2,
        background: "linear-gradient(to bottom right, black, white)",
        border:"2px solid black",
    },
    {   
        id: 3,
        name: "Player 1",
        team: "Team",
        nationality: "Nationality",
        jerseyNumber: "jerseyNumber",
        age: "Age",
        profileImage: profileImage3,
        background: "linear-gradient(to bottom right, green, white)",
        border:"2px solid green",
    },
    {   
        id: 4,
        name: "Player 1",
        team: "Team",
        nationality: "Nationality",
        jerseyNumber: "jerseyNumber",
        age: "Age",
        profileImage: profileImage4,
        background: "linear-gradient(to bottom right, red, white)",
        border:"2px solid red"
    },
]